export const product_usages = [
    'DOMESTIC', 'INDUSTRIAL', 'COMMERCIAL'
]